import React from "react";
import {Config} from '../Config';
import {NavLink} from "react-router-dom";
import IconMap from "../img/icons/icon-map.svg";
import IconMail from "../img/icons/icon-mail.svg";
import IconYoutube from "../img/icons/icon-youtube.svg";
import IconFacebook from "../img/icons/icon-facebook.svg";
import IconTwitter from "../img/icons/icon-twitter-2.svg";
import IconInstagram from "../img/icons/icon-instagram.svg";
import IconLinkedin from "../img/icons/icon-linkedin.svg";

export default function Contact(prop) {
    let [data, setData] = React.useState(null);

    React.useEffect(() => {
        let title = (prop.lang === 'en' ? 'Contact':'ติดต่อเรา') + ' | NCSA';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        (async function() {
            try {
                const resView = await getView();
                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.phone_detail = resView.phone_detail_en;
                    resView.contact = resView.contact_en;
                    resView.address = resView.address_en;
                }
                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/contact/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'contact/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Contact us':'ติดต่อเรา'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'Contact us':'ติดต่อเรา'} </p>
                </div>
            </div>

            <div className="section">
                <div className="container py-2">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="article fs-16 pe-lg-4" data-aos="fade-in">
                                <h2 className="title-underline">{data?.title}</h2>

                                <h3 className="pb-1 pt-2">
                                    <span className="text-primary h1">{data?.phone}</span>
                                    <span className="text-primary fs-14 fw-500 ps-2">{data?.phone_detail}</span>
                                </h3>

                                <ul className="contact-infos mb-0">
                                    <li>
                                        <img className="svg-js icons" src={IconMap} alt="" />
                                        <div>
                                            <p className="mb-2">{data?.address}</p>
                                        </div>
                                    </li>

                                    <li>
                                        <img className="svg-js icons" src={IconMail} alt="" />
                                        <div>
                                            {
                                                data?.email ? <p>{prop.lang === 'en' ? 'Report a cyber threat':'แจ้งเหตุภัยคุกคามไซเบอร์'} : <a className="link-danger" href={'mailto:' + data?.email}>{data?.email}</a></p> : ''
                                            }
                                            {
                                                data?.email2 ? <p>{prop.lang === 'en' ? 'Email in the middle of the secretariat':'อีเมลกลางงานสารบรรณ'} : <a className="link-danger"  href={'mailto:' + data?.email2}>{data?.email2}</a></p> : ''
                                            }
                                        </div>
                                    </li>
                                </ul>

                                <div className="pt-1 pb-2">
                                    <hr className="my-4" />
                                </div>

                                <h6 className="fs-16 fw-500">{prop.lang === 'en' ? 'Follow us':'ติดตามเรา'}</h6>

                                <div className="followus blue-dark">
                                    {
                                        data?.youtube ? <NavLink to={data?.youtube} target="_blank"><img className="icons svg-js" src={IconYoutube} alt="" /></NavLink>:''
                                    }

                                    {
                                        data?.facebook ? <NavLink to={data?.facebook} target="_blank"><img className="icons svg-js" src={IconFacebook} alt="" /></NavLink>:''
                                    }

                                    {
                                        data?.twitter ? <NavLink to={data?.twitter} target="_blank"><img className="icons svg-js twitter" src={IconTwitter} alt="" /></NavLink>:''
                                    }

                                    {
                                        data?.instagram ? <NavLink to={data?.instagram} target="_blank"><img className="icons svg-js" src={IconInstagram} alt="" /></NavLink>:''
                                    }

                                    {
                                        data?.linkedin ? <NavLink to={data?.linkedin} target="_blank"><img className="icons svg-js" src={IconLinkedin} alt="" /></NavLink>:''
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            data?.googlemapUrl ?
                                <>
                                    <div className="col-lg-5">
                                        <div className="google-map mt-md-5 mt-lg-0" data-aos="fade-in">
                                            <iframe src={data?.googlemapUrl } width="600" height="450" style={{border: 0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </> : ''
                        }
                    </div>
                </div>

            </div>
        </>
    );
} 